import { useLocation } from 'react-router-dom'
import ErrorBoundary from './ErrorBoundary'

/*
 * ErrorBoundary scoped to the routed area, keyed on the path so that navigating to a
 * different screen clears a previous screen's crash. Keeping it below <SideBar> means
 * a broken section leaves the user with working navigation instead of a dead page.
 *
 * Exists as its own component only because the boundary needs a location and App
 * renders the <Router> itself, so it has no router context of its own.
 */
export default function RouteErrorBoundary({ children }) {
    const { pathname } = useLocation()

    return (
        <ErrorBoundary name="route" resetKey={pathname}>
            {children}
        </ErrorBoundary>
    )
}
